import Filters from 'components/orders/Filters/styled';

export default Filters;
